__turbopack_context__.v({
  "chips": "chips-module-scss-module__CQfN0q__chips",
  "contained": "chips-module-scss-module__CQfN0q__contained",
  "disabled": "chips-module-scss-module__CQfN0q__disabled",
  "end-icon": "chips-module-scss-module__CQfN0q__end-icon",
  "image": "chips-module-scss-module__CQfN0q__image",
  "outline": "chips-module-scss-module__CQfN0q__outline",
  "overlay": "chips-module-scss-module__CQfN0q__overlay",
  "primary": "chips-module-scss-module__CQfN0q__primary",
  "secondary": "chips-module-scss-module__CQfN0q__secondary",
  "selected": "chips-module-scss-module__CQfN0q__selected",
  "start-icon": "chips-module-scss-module__CQfN0q__start-icon",
  "text": "chips-module-scss-module__CQfN0q__text",
});
